import { useTrack, useTrackingUuid } from '@sortlist-frontend/tracking';

import {
  HUBSPOT_DEMO_CALENDAR_SLUGS,
  HUBSPOT_DEMO_CALL_ID,
  HUBSPOT_DEMO_CALL_URL,
  HUBSPOT_MEETINGS_URL,
} from '_core/constants/hubspot';
import { usePublicAppContext } from '_core/context/public-app-context';

export const useHubSpotDemoLink = () => {
  const { locale } = usePublicAppContext();
  const { track } = useTrack({ app: 'public', locale });
  const { userUuid, sessionUuid } = useTrackingUuid();

  const trackHubSpotDemoLink = (hubspotMeetingId: string) => {
    track({
      slug: 'hubspotDemoLinkClicked',
      data: { hubspotMeetingId },
    });
  };

  const openHubSpotDemoLink = () => {
    trackHubSpotDemoLink(HUBSPOT_DEMO_CALL_ID);
    // Build the URL at click time so these UUIDs match track()'s — both read
    // client cookies. SSR-rendering them into an href would emit fresh
    // server-generated UUIDs, breaking HubSpot ↔ tracking-event reconciliation.
    const url = new URL(HUBSPOT_DEMO_CALL_URL);
    // Param names must match the HubSpot property internal names exactly
    // so the form pre-fills these fields.
    url.searchParams.set('user_uuid', userUuid);
    url.searchParams.set('session_uuid', sessionUuid);
    window.open(url.toString(), '_blank');
  };

  const openHubSpotDemoCalendar = () => {
    const calendarSlug = HUBSPOT_DEMO_CALENDAR_SLUGS[locale];
    if (calendarSlug == null) {
      openHubSpotDemoLink();
      return;
    }

    trackHubSpotDemoLink(calendarSlug);
    window.open(`${HUBSPOT_MEETINGS_URL}/${calendarSlug}`, '_blank');
  };

  return {
    openHubSpotDemoLink,
    openHubSpotDemoCalendar,
  };
};
